export default function MuiTextField(theme: any) {
  return {
    MuiTextField: {
      variants: [
        {
          props: { variant: "outlined" },
          style: {
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: theme.shape.borderRadius * 16,
              transition: "all .3s ease-in-out",
              border: `1px solid ${theme.palette.grey[700]}`,
            },
            "& :-webkit-autofill": {
              animationName: "onAutoFillStart",
              transition: `${theme.palette.grey[900]} 999999s ease-in-out 0s`,
              textFillColor: theme.palette.grey[0],
              backgroundClip: "text",
            },

            "& .Mui-focused .MuiInputBase-input + fieldset legend, & .Mui-focused .MuiInputBase-input + .MuiInputAdornment-root + fieldset legend":
              {
                paddingLeft: 7,
              },
            "& .MuiInputLabel-root": {
              color: theme.palette.grey[0],
              paddingLeft: 7,
            },
            "& .MuiFormLabel-filled + .MuiInputBase-root fieldset legend": {
              paddingLeft: 7,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: theme.palette.grey[0],
            },
            "& .MuiInputBase-input": {
              color: theme.palette.grey[0],
              "&[type='number']": {
                MozAppearance: "textfield",
              },
              "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                appearance: "none",
              },
            },
            //error
            "& .MuiInputLabel-root.Mui-error": {
              color: theme.palette.error.main,
            },
            "& .MuiFormHelperText-root": {
              fontSize: "10px",
            },
          },
        },
        {
          props: { variant: "standard" },
          style: {
            "& .MuiTouchRipple-root": {
              display: "none",
            },

            backgroundColor: "transparent",
            color: theme.palette.grey[0],
            fontWeight: "normal",
            opacity: "1",
            maxWidth: "100px",
            height: "56px",
            margin: "0px 3px",

            "& .MuiInputLabel-root.Mui-focused": {
              color: theme.palette.grey[0],
              minWidth: "100px",
            },

            "& .Mui-focused": {
              minWidth: "100px",
              height: "56px",
              color: theme.palette.common.black,
              borderBottom: "none",
            },
            "&:hover": {
              height: "56px",
              borderBottom: "none",
            },

            "& .MuiInput-root:before": {
              display: "none",
            },
            "& .MuiInput-root:after": {
              display: "none",
            },
            "& .MuiFilledInput-root:before": {
              display: "none",
            },
          },
        },
        {
          props: { variant: "outlined", size: "small" },
          style: {
            marginTop: "15px",
            height: "40px",
            padding: 0,
            fontSize: "14px",
            "& input::placeholder": {
              fontSize: "14px",
              opacity: 1,
              padding: 0,
            },
            "& input": {
              height: "40px",
              padding: 0,
            },
            "& .MuiInputBase-input": {
              height: "40px",
              paddingLeft: "20px",
            },
          },
        },
      ],
      styleOverrides: {
        root: {},
      },
    },
  };
}
